import * as AppConstants from "AppConstants";
import { getDateInFormat } from "utils/dateUtil";

export const getUrlForHolidayCalendars = () => {
    return AppConstants.GET_HOLIDAY_CALENDARS_ENDPOINT;
};

export const getUrlForCalendarHolidays = (calendarId) => {
    return AppConstants.GET_CALENDAR_HOLIDAYS_ENDPOINT
                        .replace(AppConstants.CALENDAR_ID_PLACEHOLDER, calendarId);
};

/**
 * Builds the server-paginated calendar-holidays URL with page/sort/search query params.
 * GET /v1/api/holiday-calendars/{calendarId}/holidays/paged?pageNumber=&pageSize=&sortBy=&sortDirection=&searchQuery=
 */
export const getUrlForCalendarHolidaysPage = (calendarId, { page, pageSize, sortBy, sortDirection, searchQuery }) => {
    const base = AppConstants.GET_CALENDAR_HOLIDAYS_PAGED_ENDPOINT
                        .replace(AppConstants.CALENDAR_ID_PLACEHOLDER, calendarId);
    const params = new URLSearchParams({
        pageNumber: String(page ?? 0),
        pageSize: String(pageSize ?? 10),
        sortBy: sortBy ?? "holidayDate",
        sortDirection: sortDirection ?? "ASC",
    });
    if (searchQuery) params.append("searchQuery", searchQuery);
    return `${base}?${params.toString()}`;
};

export const getUrlToCreateHoliday = (calendarId) => {
    return AppConstants.CREATE_CALENDAR_HOLIDAY_ENDPOINT
                        .replace(AppConstants.CALENDAR_ID_PLACEHOLDER, calendarId);
};

export const getUrlToUpdateHoliday = (calendarId, holidayId) => {
    return AppConstants.UPDATE_CALENDAR_HOLIDAY_ENDPOINT
                        .replace(AppConstants.CALENDAR_ID_PLACEHOLDER, calendarId)
                        .replace(AppConstants.HOLIDAY_ID_PLACEHOLDER, holidayId);
};

export const getUrlToDeleteHoliday = (calendarId, holidayId) => {
    return AppConstants.DELETE_CALENDAR_HOLIDAY_ENDPOINT
                        .replace(AppConstants.CALENDAR_ID_PLACEHOLDER, calendarId)
                        .replace(AppConstants.HOLIDAY_ID_PLACEHOLDER, holidayId);
};

export const getUrlForApplicableHolidays = (fromDate, toDate) => {
    return AppConstants.GET_APPLICABLE_HOLIDAYS_ENDPOINT
                        .replace(AppConstants.FROM_DATE_PLACEHOLDER, getDateInFormat(fromDate))
                        .replace(AppConstants.TO_DATE_PLACEHOLDER, getDateInFormat(toDate));
};

export const getUrlForOptionalHolidays = (ownerId, isMember, year) => {
    return AppConstants.GET_OPTIONAL_HOLIDAYS_ENDPOINT
                        .replace(AppConstants.OWNER_ID_PLACEHOLDER, ownerId)
                        .replace(AppConstants.IS_MEMBER_PLACEHOLDER, isMember)
                        .replace(AppConstants.YEAR_PLACEHOLDER, year);
};

export const getUrlForHolidayElection = (holidayId, ownerId, isMember) => {
    return AppConstants.HOLIDAY_ELECTION_ENDPOINT
                        .replace(AppConstants.HOLIDAY_ID_PLACEHOLDER, holidayId)
                        .replace(AppConstants.OWNER_ID_PLACEHOLDER, ownerId)
                        .replace(AppConstants.IS_MEMBER_PLACEHOLDER, isMember);
};